export type EntryFlowKind = "normalEntry" | "ownerOnboarding";

export function resolveEntryFlowKind(
  ownerOnboardingToken: string,
  hasOwnerOnboardingTokenQueryParam: boolean
): EntryFlowKind {
  return hasOwnerOnboardingTokenQueryParam || ownerOnboardingToken.trim().length > 0
    ? "ownerOnboarding"
    : "normalEntry";
}
